import { lazy, Suspense } from 'react';
import { LoadingScreen } from '@/components/feedback/loading-screen';

// Lazy load pages
const OpportunityStageListPage = lazy(() =>
  import('@pages/settings/accounts/opportunities/stages/list').then((m) => ({
    default: m.OpportunityStageListPage,
  }))
);

const OpportunityStageCreatePage = lazy(() =>
  import('@pages/settings/accounts/opportunities/stages/create').then((m) => ({
    default: m.OpportunityStageCreatePage,
  }))
);

const OpportunityStageEditPage = lazy(() =>
  import('@pages/settings/accounts/opportunities/stages/edit').then((m) => ({
    default: m.OpportunityStageEditPage,
  }))
);

export const opportunitySettingsRoutes = [
  {
    path: 'opportunities',
    children: [
      { element: <OpportunityStageListPage />, index: true },
      {
        path: 'stages',
        children: [
          {
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <OpportunityStageListPage />
              </Suspense>
            ),
            index: true,
          },
          {
            path: 'list',
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <OpportunityStageListPage />
              </Suspense>
            ),
          },
          {
            path: 'new',
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <OpportunityStageCreatePage />
              </Suspense>
            ),
          },
          {
            path: ':id/edit',
            element: <OpportunityStageEditPage />,
          },
        ],
      },
    ],
  },
];
